import { Box, Container, Typography } from "@mui/material";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import BuildIcon from "@mui/icons-material/Build";
import LayersIcon from "@mui/icons-material/Layers";
import EngineeringIcon from "@mui/icons-material/Engineering";

const capabilities = [
  {
    title: "High-Precision Fabrication",
    icon: <PrecisionManufacturingIcon sx={{ fontSize: 42 }} />,
    desc: "Advanced machinery enabling accurate and efficient steel fabrication.",
  },
  {
    title: "CNC Bending & Cutting",
    icon: <BuildIcon sx={{ fontSize: 42 }} />,
    desc: "Automated precision bending and cutting with perfect repeatability.",
  },
  {
    title: "Welding & Structural Assembly",
    icon: <LayersIcon sx={{ fontSize: 42 }} />,
    desc: "Certified welding teams delivering high-strength industrial structures.",
  },
  {
    title: "Painting & Surface Finishing",
    icon: <EngineeringIcon sx={{ fontSize: 42 }} />,
    desc: "Durable coatings ensuring corrosion resistance and long-term reliability.",
  },
];

export default function FactoryCapabilities() {
  return (
    <Box
      sx={{
        py: 10,
        background: "linear-gradient(135deg, #0d0f19, #111627, #0b0e18)",
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          sx={{
            fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2.2rem" },
            fontWeight: 900,
            textAlign: "center",
            mb: 6,
            color: "#ffffff",
            lineHeight: 1.25,
            textShadow: "0px 0px 12px rgba(26,35,126,0.6)",
            maxWidth: "92%",
            mx: "auto",
            wordBreak: "break-word",
          }}
        >
          Factory / Production Capabilities Preview
        </Typography>

        {/* Flexbox Cards */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 4,
            justifyContent: "center",
          }}
        >
          {capabilities.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: { xs: "100%", sm: "45%", md: "22%" },
                background: "rgba(255,255,255,0.06)",
                borderRadius: 4,
                p: 3,
                textAlign: "center",
                backdropFilter: "blur(6px)",
                border: "1px solid rgba(255,255,255,0.08)",
                boxShadow: "0px 8px 30px rgba(0,0,0,0.45)",
                transition: "all 0.35s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  border: "1px solid rgba(26,35,126,0.6)",
                  boxShadow: "0px 12px 40px rgba(26,35,126,0.4)",
                },
              }}
            >
              {/* Icon */}
              <Box
                sx={{
                  color: "#90caf9",
                  mb: 2,
                  filter: "drop-shadow(0 0 10px rgba(26,35,126,0.7))",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {item.icon}
              </Box>

              {/* Title */}
              <Typography
                sx={{
                  color: "#ffffff",
                  fontWeight: 700,
                  fontSize: "1.15rem",
                  mb: 1.5,
                }}
              >
                {item.title}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: "0.95rem",
                  lineHeight: 1.5,
                }}
              >
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
